export function translateFn(message: string, parameters?: Object) {
  if (!globalThis.nirvana.translator) {
    throw new Error('Global Nirvana Translator not defined');
  }
  return globalThis.nirvana.translator.translateFn(message, parameters);
}
